<template>
  <v-slide-group dark class="training-calendar">
    <v-slide-item v-for="day in days" :key="day.fullDate">
      <div
        class="day-card ma-2"
        :class="{
          'day-card--workout': day.hasWorkout,
          'day-card--today': day.isToday,
        }">
        <div class="day-info">
          <div class="day-of-week">{{ day.dayOfWeek }}</div>
          <div class="day-of-month">{{ day.dayOfMonth }}</div>
        </div>
        <div class="workout-indicator">
          <v-icon v-if="day.hasWorkout" color="white" small>mdi-fire</v-icon>
        </div>
      </div>
    </v-slide-item>
  </v-slide-group>
</template>

<script>
export default {
  name: "TrainingCalendar",
  props: {
    // KORREKTUR: Prop von 'workouts' zu 'sessions' umbenannt für Klarheit.
    sessions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      days: [],
    }
  },
  computed: {
    // KORREKTUR: Diese Logik nutzt jetzt die 'sessions'-Prop und ihre Struktur.
    workoutDates() {
      const dates = this.sessions
        // Sicherheitsfilter, falls ein Eintrag fehlerhaft ist.
        .filter((session) => session && session.execution && session.execution.createdAt)
        .map((session) => this.$moment(session.execution.createdAt).format("YYYY-MM-DD"))
      return new Set(dates)
    },
  },
  mounted() {
    this.generateDays()
  },
  methods: {
    generateDays() {
      const today = this.$moment()
      const tempDays = []
      for (let i = 0; i < 30; i++) {
        const date = this.$moment().subtract(i, "days")
        const fullDate = date.format("YYYY-MM-DD")

        tempDays.push({
          fullDate: fullDate,
          dayOfWeek: date.format("dd"),
          dayOfMonth: date.format("D"),
          isToday: date.isSame(today, "day"),
          hasWorkout: this.workoutDates.has(fullDate),
        })
      }
      this.days = tempDays.reverse()
    },
  },
}
</script>

<style scoped>
.day-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 65px;
  height: 90px;
  border-radius: 18px;
  background-color: rgba(255, 255, 255, 0.08);
  border: 1px solid transparent;
  padding: 10px;
  transition: all 0.3s ease;
  cursor: pointer;
  font-weight: bold;
}

.day-card:hover {
  background-color: rgba(255, 255, 255, 0.15);
  transform: translateY(-4px);
}

.day-info {
  text-align: center;
}

.day-of-week {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.6);
  text-transform: capitalize;
}

.day-of-month {
  font-size: 1.4rem;
  color: white;
  line-height: 1.2;
}

.workout-indicator {
  height: 20px;
  text-align: center;
}

.day-card--today {
  border: 1.5px solid #f5f5f5;
}

.day-card--workout {
  background: linear-gradient(135deg, #e75a7c 0%, #b34a70 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(231, 90, 124, 0.3);
}

.day-card--workout .day-of-week {
  color: rgba(255, 255, 255, 0.8);
}
</style>
